<template>
  <div class="modal">
    <div class="modal-content new-banner-modal">
      <p class="btn" v-on:click="closeModal">x</p>
      <form v-on:submit.prevent="handleFormSubmit">
        <label for="image" class="preview" :style="{'background-color': color}">
          <p v-if="!filePreview">Select Image</p>
          <img v-if="filePreview" :src="filePreview" alt="">
        </label>
        <input
          @change="handleImageSelected" 
          type="file" 
          class="image-input" 
          id="image"
        >
        <div class="label required">Product</div>
        <div class="input-ctn">
            <input type="text" v-model="productLabel" placeholder="Product" onkeydown="event.preventDefault()" class="input" @focus="openLocalProductModal">
        </div>
        <div class="input-ctn">
          <div class="label">Order</div>
          <input style="border: solid 1px; width: 100%;" type="number" v-model="order" step="1" class="input">
        </div>
        <!-- <div class="input-ctn">
          <div class="label">Color</div>
          <input type="color" v-model="color" class="input color-input">
        </div> -->
        <div class="submit-group">
          <button type="submit" class="btn submit">
            Create
          </button>
        </div>
      </form>
    </div>
        <SelectLocalProductModal
            :closeModal="closeLocalProductModal"
            v-show="productModalOpened"
            :onSubmit="selectedProduct"
        />
  </div>
</template>

<script>
import { FileUpload } from "../../handler";
import SelectLocalProductModal from "../../components/SelectLocalProductModal";

export default {
  components: {
      SelectLocalProductModal
  },
  props: ['closeModal'],
  data() {
    return {
      file: null,
      filePreview: '',
      color: '#000',
      order: 20,
      product: null,
      productLabel: '',
      productModalOpened: false
    }
  },
  methods: {
    async handleFormSubmit() {
      if(!this.product) {
        return false;
      }
      const file = await FileUpload.uploadFile(this.file)
      const data = {
        image: file.path,
        image: file.path,
        bgColor: '#000',
        order: this.order,
        product: this.product._id
      }
      const done = await this.$store.dispatch('topBannerModule/createTopBanner', data)
      if(done) {
        this.closeModal()
      }
    },
    handleImageSelected(e) {
      const file = e.target.files[0]
      this.file = file
      this.filePreview = URL.createObjectURL(file)
    },
    openLocalProductModal() {
        this.productModalOpened = true;
        setTimeout(() => {
            document.getElementById("selectProductModelSearchInput").focus();
        })
    },
    closeLocalProductModal() {
        this.productModalOpened = false;
    },
    selectedProduct(product) {
        if(this.product == product) {
            return;
        }

        if(product) {
            this.productLabel = product.name;
        } else {
            this.productLabel = null;
        }
        this.product = product;
    },
  }
}
</script>

<style>

</style>